<template>
  <main class="p-mailaddresschange l-page">
    <section class="p-mailaddresschange__wrap">
      <h2 class="c-regist__title">{{ title }}</h2>
      <p class="c-regist__comment message">{{ statusMessage }}</p>
      <ul v-if="state.status === 'Error'" class="p-mailaddresschange__notes">
        <li class="p-mailaddresschange__note">
          {{ t('MailAddressChangePage.message1') }}
        </li>
        <li class="p-mailaddresschange__note">
          {{ t(`MailAddressChangePage.${isKokoBuild ? 'message2_koko' : 'message2'}`) }}
        </li>
        <li class="p-mailaddresschange__note">
          {{ t('MailAddressChangePage.message3') }}
        </li>
      </ul>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent, reactive, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import StoreUtil from '@/stores/StoreUtil'

export default defineComponent({
  name: 'MailAddressChangePage',
  setup() {
    const router = useRouter()
    const { t } = useI18n()
    const state = reactive({
      tokenId: '',
      status: 'Processing', // タイトル、メッセージの取得にも使用するので1文字目は大文字にすること
    })
    const messageDialogStore = StoreUtil.useStore('MessageDialogStore')
    const MailAddressChangeStore = StoreUtil.useStore('MailAddressChangeStore')
    const ErrorStore = StoreUtil.useStore('ErrorStore')
    /**
     * タイトルを取得する：処理ステータスにより変化する
     */
    const title = computed(() => {
      return t(`MailAddressChangePage.title${state.status}`)
    })
    /**
     * メッセージを取得する：処理ステータスにより変化する
     */
    const statusMessage = computed(() => {
      return t(`MailAddressChangePage.message${state.status}`)
    })

    /**
     * 教育向け（KOKO）ビルドかどうか
     */
    const isKokoBuild = computed(() => {
      return process.env.VUE_APP_BUILD_TARGET === 'koko'
    })

    onMounted(async () => {
      if (
        !router.currentRoute.value.query.tokenId ||
        typeof router.currentRoute.value.query.tokenId !== 'string'
      ) {
        state.status = 'Error'
        ErrorStore.setConfig('tokenInvalid.changeMailAddress')
        router.replace({ name: 'ErrorPage' })
        return
      }
      MailAddressChangeStore.tokenId = router.currentRoute.value.query.tokenId
      const submitResult = await MailAddressChangeStore.changeMailAddress()
      if (submitResult.isSuccess) {
        router.replace({ name: 'MailAddressChangeCompletePage' })
      } else {
        state.status = 'Error'
        let dialogOptions = {}
        switch (submitResult.res.response.data.error_code) {
          case '404_0001': {
            dialogOptions = {
              title: t('MailAddressChangePage.dialog.invalidUser.title'),
              message: t('MailAddressChangePage.dialog.invalidUser.message'),
              status: 'error',
            }
            break
          }
          case '400_0042': {
            ErrorStore.setConfig('tokenInvalid.changeMailAddress')
            router.replace({ name: 'ErrorPage' })
            return
          }
          case '404_0000': {
            dialogOptions = {
              title: t('MailAddressChangePage.dialog.invalidParameter.title'),
              message: t('MailAddressChangePage.dialog.invalidParameter.message'),
              status: 'error',
            }
            break
          }
          case '409_0000': {
            dialogOptions = {
              title: t('MailAddressChangePage.dialog.duplicatedMailAddress.title'),
              message: t(
                `MailAddressChangePage.dialog.duplicatedMailAddress.${
                  isKokoBuild.value ? 'message_koko' : 'message'
                }`,
              ),
              status: 'error',
            }
            break
          }
          case 'NETWORK_ERROR': {
            dialogOptions = {
              title: t('dialog.netWorkError.title'),
              message: t('dialog.netWorkError.message'),
              status: 'error',
            }
            break
          }
          default: {
            dialogOptions = {
              title: t('dialog.unknownError.title'),
              message: t('dialog.unknownError.message', [
                submitResult.res.response.data.error_code,
              ]),
              status: 'error',
            }
            break
          }
        }
        await messageDialogStore.openWithSettings(dialogOptions)
      }
    })
    return {
      state,
      t,
      title,
      statusMessage,
      isKokoBuild,
    }
  },
  components: {},
})
</script>

<style scoped lang="scss"></style>
